export interface DebouncedGate {
    wait: () => Promise<boolean>;
    cancel: () => void;
}

export const createDebouncedGate = (delay = 300): DebouncedGate => {
    let timer: ReturnType<typeof setTimeout> | undefined;
    let resolvePending: ((shouldProceed: boolean) => void) | undefined;

    const cancel = () => {
        if (timer) {
            clearTimeout(timer);
            timer = undefined;
        }

        resolvePending?.(false);
        resolvePending = undefined;
    };

    const wait = () =>
        new Promise<boolean>((resolve) => {
            cancel();
            resolvePending = resolve;
            timer = setTimeout(() => {
                timer = undefined;
                resolvePending = undefined;
                resolve(true);
            }, delay);
        });

    return { wait, cancel };
};
